import BusinessIcon from '@mui/icons-material/Business';
import {
  Box,
  Card,
  CardContent,
  Container,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Logo } from '../components/Logo';
import { useSelectedTenant } from './tenantSelection';

/**
 * The full-page stop between signing in and working: a caller who could mean more than one tenant
 * has to say which, exactly as the API demands per request. Only multi-tenant non-administrators
 * ever land here — an administrator starts in administration and picks a tenant from the toolbar,
 * and TenantGate has already handled a caller context that failed to load.
 */
export function TenantChooser() {
  const { t } = useTranslation();
  const { tenants, selectTenant } = useSelectedTenant();

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <Logo width={220} height="auto" />
      </Box>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h6">{t('tenants.chooseTitle')}</Typography>
            <Typography color="text.secondary">{t('tenants.chooseBody')}</Typography>

            <List>
              {tenants.map((tenant) => (
                <ListItemButton key={tenant.tenantGid} onClick={() => selectTenant(tenant.tenantGid)}>
                  <ListItemIcon>
                    <BusinessIcon />
                  </ListItemIcon>
                  <ListItemText primary={tenant.name} />
                </ListItemButton>
              ))}
            </List>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  );
}
